let lunr = require('lunr');

export default class AutoSuggest {
	constructor(config) {
		try {
			this.searchInput = config.input;
			this.hiddenResults = true;
			this.timerDelayHide = undefined;
			this.onChange = config.onChange || false;

			this.bulletContainer = undefined;
			this.bulletPoints = {};  // file_uid => key
			if (this.searchInput.hasAttribute('data-bullets')) {
				this.bulletContainer = document.querySelector(this.searchInput.getAttribute('data-bullets'));
				this.bulletContainer.addEventListener('click', this.#removeBulletPoint.bind(this));
			}

			// Create search results container
			let _ro = document.createElement('div');
			_ro.classList.add(...[ 'hidden', 'auto-suggest' ]);
			let _ro_ul = document.createElement('ul');
			_ro.classList.add('auto-suggest__results');
			_ro.appendChild(_ro_ul);
			this.resultsOuput = _ro_ul;
			this.searchInput.parentNode.appendChild(_ro);

			// Setup lunr
			this.files = config.files;
			this.mapFileIdToIndex = config?.files.reduce((map, file, i) => {
				map[file.uid] = i;
				return map;
			}, {});

			// Build index, from storage if possible
			let getRoundedDate = (minutes, d = new Date()) => {
				let ms = 1000 * 60 * minutes; // convert minutes to ms
				let roundedDate = new Date(Math.round(d.getTime() / ms) * ms);

				return roundedDate.getFullYear() + '' + (roundedDate.getMonth()+1) + '' + roundedDate.getDate() + '' + roundedDate.getHours() + '' + roundedDate.getMinutes();
			};

			let _id = getRoundedDate(5, new Date());
			let idx = localStorage.getItem(`lunr-index`) || false;
			let createIndex = true;
			if (idx) {
				idx = JSON.parse(idx);
				if (typeof(idx[_id]) !== 'undefined') {
					this.index = lunr.Index.load(idx[_id]);
					createIndex = false;
				}
			}

			if (createIndex) {
				this.index = lunr(function() {
					this.ref('uid')
					this.field('title');
					this.field('description');
					this.field('keywords');

					config?.files.forEach(doc => {
						// Makes it possible to search for SF 2 -> to get SF 25 as result,
						// or Stulppaneel to get "Verlegung Stulppaneel" as suggestion
						//? Drawback: You need to replace __ in keywords with a space when using them in the UI
						doc.keywords = doc.keywords?.replace(', ', ',').replace(' ', '__');
						this.add(doc);
					}, this);
				});
				let json = {};
				json[_id] = this.index;
				let serializedIdx = JSON.stringify(json);
				try {
					localStorage.setItem(`lunr-index`, serializedIdx);
				} catch (s) {
					// in case index is too big or no storage space left -> cleanup
					localStorage.removeItem('lunr-index');
				}
			}

			let toSearch = undefined;
			let startSearch = (query) => {
				if (query.length < 3) {
					return;
				}

				let sTerm = query.replace(/:/, '\:').replace(' ', '__');
				if (!sTerm.includes('*')) {
					// Enable partial matching by default, the longer the word, the less the allowed variance -> performance degrades
					sTerm = `${ sTerm } *${ sTerm }* *${ sTerm } ${ sTerm }*`;
				}

				// we use the first X search results to reduce the unique keywords out
				let results = this.index.search(sTerm).slice(0, 100);
				let mapPushedKeyword = {};
				this.showResults(results.reduce((acc, match) => {
					let file = this.files[ this.mapFileIdToIndex[match.ref] ];

					file?.keywords?.toLowerCase().split(',').forEach(key => {
						let _key = key.trim().replace(/[,\)\-\.;]$|^\(/, '').replace('__', ' ');
						if (mapPushedKeyword[_key]) {
							return;
						}

						if (_key.indexOf(query) > -1) {
							acc.push({ uid: file.uid, keyword: _key });
							mapPushedKeyword[_key] = true;
						}
					});

					let words = file.description?.toLowerCase().split(' ') || [];
					words.forEach(word => {
						let w = word.trim().replace(/[,\)\-\.;]$|^\(/, '').replace('__', ' ');
						if (mapPushedKeyword[w]) {
							return;
						}

						if (w.indexOf(query) > -1) {
							acc.push({ uid: file.uid, keyword: w });
							mapPushedKeyword[w] = true;
						}
					});

					words = file.title?.toLowerCase().split(' ') || [];
					words.forEach(word => {
						let w = word.trim().replace(/[,\)\-\.;]$|^\(/, '').replace('__', ' ');
						if (mapPushedKeyword[w]) {
							return;
						}
						if (w.indexOf(query) > -1) {
							acc.push({ uid: file.uid, keyword: w });
							mapPushedKeyword[w] = true;
						}
					});

					return acc;
				}, []).sort((a, b) => a.keyword.localeCompare(b.keyword)));
			};

			// Attach events
			this.searchInput.addEventListener('input', e => {
				this.hideResults();

				toSearch = clearTimeout(toSearch);
				toSearch = setTimeout(() => {
					startSearch(e.target.value.toLowerCase());
				}, 200);
			});

			this.searchInput.addEventListener('blur', e => {
				// delay, in case of click on search result item, blur event interrupts the click event
				this.timerDelayHide = setTimeout(() => this.hideResults(false), 200);
			});
			_ro_ul.addEventListener('click', e => {
				this.timerDelayHide = clearTimeout(this.timerDelayHide);

				if (e.target.hasAttribute('data-uid') && e.target.hasAttribute('data-key')) {
					this.selectResult(e.target.getAttribute('data-uid'), e.target.getAttribute('data-key'));
				}
			});

			[ 'focus', 'click' ].forEach(event => {
				this.searchInput.addEventListener(event, e => {
					if (e.target?.value?.length > 0) {
						this.showResults();
					}
				});
			});
		} catch (err) {
			console.error(err);
		}
	}

	/**
	 * Gets the currently "active" bullet points.
	 *
	 * @returns {Object}
	 */
	getBulletPoints() {
		return this.bulletPoints;
	}

	/**
	 * Sets a new set of bullet points.
	 *
	 * @param {Object} bulletPoints
	 */
	setBulletPoints(bulletPoints) {
		this.bulletPoints = bulletPoints;
		this.#updateBulletPoints();
	}

	/**
	 * Creates the bullet point list.
	 */
	#updateBulletPoints() {
		let keys = Object.keys(this.bulletPoints);

		let ul = document.createElement('ul');
		for (let i = 0; i < keys.length; ++i) {
			let li = document.createElement('li');
				li.classList.add(...['dc-bullet-item', 'js-dc-search-bullet-item']);
				li.setAttribute('data-uid', keys[i]);
				li.setAttribute('data-key', this.bulletPoints[ keys[i] ]);
			let span = document.createElement('span');
				span.classList.add(...['dc-bullet-label', 'js-bullet-text']);
				span.innerHTML = this.bulletPoints[ keys[i] ];
			li.appendChild(span);
			ul.appendChild(li);
		}

		this.bulletContainer.innerHTML = ul.innerHTML;
	}

	/**
	 * Click on the bulletContainer.
	 * Perhaps removal of a bullet point.
	 *
	 * @param {Event} e
	 */
	#removeBulletPoint(e) {
		let target = e.target;
		if (e.target.classList.contains('js-bullet-text')) {
			target = e.target.parentNode;
		}
		target.remove();

		delete this.bulletPoints[ target.getAttribute('data-uid') ];
		this.onChange && this.onChange(false);
	}

	/**
	 * Clicking a search result will select it and saveit as bullet point.
	 *
	 * @param {integer}	uid
	 * @param {string}	key
	 */
	selectResult(uid, key) {
		if (this.bulletContainer) {
			this.bulletPoints[ uid ] = key.trim();
			this.searchInput.value = '';
			this.#updateBulletPoints();
		} else {
			this.searchInput.value = key;
		}

		this.searchInput.dispatchEvent(new Event('blur'));
		this.onChange && this.onChange(false);
	}

	/**
	 * Show a set of search results in the autosuggest.
	 *
	 * @param {Array} results
	 */
	showResults(results = []) {
		if (results.length > 0) {
			results.forEach(result => {
				let _li = document.createElement('li');
				_li.innerHTML = result.keyword;
				_li.classList.add('auto-suggest__item');
				_li.setAttribute('data-uid', result.uid);
				_li.setAttribute('data-key', result.keyword);
				this.resultsOuput.appendChild(_li);
			});

			this.resultsOuput.parentNode.classList.remove('hidden');
			this.hiddenResults = false;
		}
	}

	/**
	 * Hide the autosuggests.
	 *
	 * @param {boolean} emptyContent
	 */
	hideResults(emptyContent = true) {
		this.resultsOuput.parentNode.classList.add('hidden');
		if (emptyContent) {
			this.resultsOuput.innerHTML = '';
		}

		this.hiddenResults = true;
	}

	/**
	 * Empties the clicked search results.
	 */
	clearSearch() {
		if (this.bulletContainer) {
			this.bulletContainer.innerHTML = '';
			this.bulletPoints = {};
		}
	}
}
